import { BaseDataModel } from "@domain/CRM/BaseDataModel";
import { TeamRoleOption, TeamStatusOption } from "@rogoag/airtable";

export class TeamMember extends BaseDataModel {
	name!: string;
	missionControlUsername!: string;
	appUserId!: number;
	password?: string;
	status!: TeamStatusOption;
	phoneNumber!: string;
	isAppLoginApproved!: boolean;
}

/** Fields needed to create (onboard) a new operator + its login password.
 *  The App Username is derived server-side from the name, so it isn't supplied here. */
export interface CreateOperatorInput {
	name: string;
	password: string;
	phoneNumber: string;
	status: TeamStatusOption;
	roles: TeamRoleOption[];
	isAppLoginApproved: boolean;
}
